<juridico-header></juridico-header>
<main id="main">
  <div class="recuperar-senha ">
    <div class="row">
      <div class="col-lg-4 mr-auto ml-auto justify-content-center">
        <div>
          <h3 class="title">Cadastre sua nova senha!</h3>

          <div class="alert alert-danger" *ngIf="error">
            Token de alteração de senha expirado, solicite recuperar senha novamente!
          </div>
          <div class="alert alert-danger" *ngIf="isNotEquals">
            Por gentileza, repita a mesma senha
          </div>
          <div class="alert alert-success" *ngIf="sucesso">
            Senha Alterada com sucesso!&nbsp;
            <a *ngIf="sucesso" href="/login" routerLink='/login'>Clique aqui e faça login</a>
          </div>

          <form *ngIf="!sucesso" class="form" #dados = "ngForm" novalidate (ngSubmit) = "alterarSenha(dados)">
            <label>Nova Senha (mínimo de 6 digitos):</label>
            <input type="password" class="form-control" required minlength="6" name="senha" placeholder="Nova Senha" [(ngModel)]="NewPassword">

            <label>Confirmar Senha:</label>
            <input type="password" class="form-control" required minlength="6" name="confirmacaoSenha" placeholder="Confirmar Senha" [(ngModel)]="ConfirmPassword">

            <button type="submit" class="btn btn-primary btn-block btn-round" [disabled]="dados.invalid || (dados.value.confirmacaoSenha != dados.value.senha)">Alterar senha</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
<juridico-footer></juridico-footer>